import { ICommand } from 'core-ts-types';
import { AlternatePlanChangePlanPopupDetailsQuery } from '../../../alternate_plans/queries/alternate_plan_change_plan_popup_details_query';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';

class AlternatePlanChangePlanPopupController {
  private showPopup: boolean = true;
  constructor(
    private $state: any,
    private changeSpecializationPlanCommand: ICommand,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAlternatePlanChangePlanPopupDetailsQuery: AlternatePlanChangePlanPopupDetailsQuery
  ) {}

  changePlanOpenedChanged($event: any) {
    this.showPopup = $event.detail.value;
    if (!this.showPopup) {
      this.$state.go('^.^.alternate-plans');
    }
  }

  changePlan() {
    this.changeSpecializationPlanCommand().then(() => {
      const stateName = this.ngAPUserModeConfig.isAdvisor()
        ? 'ap-advisor.plan.view.default'
        : 'my.planner.plan.default';
      this.$state.go(stateName, {}, { reload: true });
    });
  }

  closePopup() {
    this.showPopup = false;
  }
}
angular.module('capability-ng-academic-planner').component('alternatePlanChangePlanPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_change_plan_popup/alternate_plan_change_plan_popup.html',
  controller: AlternatePlanChangePlanPopupController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_change_plan_popup/alternate_plan_change_plan_popup.ts